import { Box, Button, FormControl, InputLabel, MenuItem, Select, Typography, useMediaQuery, useTheme, Dialog } from "@mui/material";
import { TEXT_TITLE_COLOR } from "../../constants/colors";
import ConfirmDialog from "../../components/ConfirmDialog";
import { EN_ACCEPT_LANGUAGE } from "../../constants/acceptLanguageApi";
import { useTranslation } from "react-i18next";
import ErrorMessageComponent from "../../components/errorMessage";
import useFormCategoryController from "./controller/formCategory";
import { SuppliesCategoryProduct } from "../../models/suppliesCategoryProduct";

interface Props {
    onClose: VoidFunction;
    onRefetchData: VoidFunction;
    dataMasterCategory: SuppliesCategoryProduct[];
    merchantId: string,
    openForm: boolean,
    divisionId: string
}

const FormCategory = ({ onClose, onRefetchData, merchantId, openForm, dataMasterCategory, divisionId }: Props) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const { i18n } = useTranslation("global");
    const controller = useFormCategoryController({
        dataMasterCategory,
        merchantId,
        divisionId,
        onRefetchData,
        onClose
    });

    return (
        <Dialog
            fullWidth
            maxWidth={'lg'}
            open={openForm}
        >
            <form>
                <Box sx={{ p: isSmallScreen ? 2 : 6 }}>
                    <Box mb={isSmallScreen ? 1 : 2}>
                        <Typography variant="h4" color={TEXT_TITLE_COLOR} fontWeight='bold'>
                            Category
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            p: isSmallScreen ? 2 : 4,
                            boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                        }}
                    >
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="category-label-id" shrink={true}>Category</InputLabel>
                            <Select
                                labelId="category-label-id"
                                id="category-id"
                                value={controller.categoryValue}
                                label="Category"
                                onChange={controller.handleCategoryChange}
                                sx={{
                                    maxWidth: 250
                                }}
                            >
                                {
                                    dataMasterCategory?.map((item: SuppliesCategoryProduct) => <MenuItem key={item?.id} value={item?.id}>{i18n.language === EN_ACCEPT_LANGUAGE ? item?.category_name_en : item?.category_name_la}</MenuItem>)
                                }
                            </Select>
                        </FormControl>
                    </Box>
                    <ErrorMessageComponent errorMessage={controller.errorMessage} />
                    <Box mt={isSmallScreen ? 4 : 2} sx={{ display: 'flex', justifyContent: isSmallScreen ? 'center' : 'end' }}>
                        <Button
                            variant='outlined'
                            color="error"
                            sx={{ textTransform: 'none', mr: isSmallScreen ? 1 : 2, width: 100 }}
                            onClick={() => {
                                onClose();
                                controller.handleSetErrorMessage(null!);
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            onClick={controller.handleOpenConfirmDialog}
                            color="secondary"
                            sx={{ textTransform: 'none', color: '#fff', width: 150 }}
                        >
                            Create
                        </Button>
                    </Box>
                </Box>
                <ConfirmDialog
                    open={controller.openConfirmDialog}
                    title={`Do you want to create data?`}
                    loading={controller.loadingConfirmDialog}
                    onCancel={controller.handleCloseConfirmDialog}
                    onConfirm={controller.handleClickConfirmButton}
                />

            </form>
        </Dialog>
    )
}
export default FormCategory;
